var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooter2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 115,
    viewBox: "0 0 68 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150 40C150 81.4214 116.421 115 75 115C33.5786 115 0 81.4214 0 40C0 -1.42136 33.5786 -35 75 -35C116.421 -35 150 -1.42136 150 40ZM24.0149 40C24.0149 68.1583 46.8417 90.9851 75 90.9851C103.158 90.9851 125.985 68.1583 125.985 40C125.985 11.8417 103.158 -10.9851 75 -10.9851C46.8417 -10.9851 24.0149 11.8417 24.0149 40Z",
    fill: "#A1C6E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter2);
export default __webpack_public_path__ + "static/media/footer-2.e4347e196cb7aba23350703105ab9cb6.svg";
export { ForwardRef as ReactComponent };